import { render, staticRenderFns } from "./RootArticleList.vue?vue&type=template&id=4ea3dd9e&scoped=true"
import script from "./RootArticleList.vue?vue&type=script&lang=ts"
export * from "./RootArticleList.vue?vue&type=script&lang=ts"
import style0 from "./RootArticleList.vue?vue&type=style&index=0&id=4ea3dd9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3dd9e",
  null
  
)

export default component.exports